import { int } from "@goodgamestudios/math-utilities";

export class MathUtils {
    public static radiansToDegrees(rad: number): number {
        return rad * 180 / Math.PI;
    }

    public static degreesToRadians(deg: number): number {
        return deg * Math.PI / 180;
    }

    /**
     *  You have X and need to find what number is closest to it in an array
     *  arg is the number your are looking to put into a bucket. buckets is an array of number aka buckets.
     */
    public static findClosestToX(p_x: number, buckets: any[]): number {
        var lowest: number = NaN;
        var item: number = int(buckets.length - 1);
        for (var i: number = 0; i < buckets.length; i++) {
            var delta: number = Math.abs(buckets[i] - p_x);
            if (isNaN(lowest) || lowest > delta) {
                lowest = delta;
                item = i;
            }
        }
        return buckets[item];
    }

    /**
     * round to the nearest number
     *
     * e.g.:
     *    	1. roundToNearest(100, 3745);
     *		2. 3745/100 = 37.45
     *		3. Math.round(37.45) //37
     *		4. 37*100 = 3700
     */
    //		public static function roundToNearest( roundTo:Number, value:Number ) : Number
    //		{
    //			return Math.round(value/roundTo)*roundTo;
    //		}

    /**
     * Methode rundet einen wert auf eine bestimmte anzahl vonnachkommastellen
     * @param value der zu rundende wert
     * @param decimal anzahl der nachkommastellen
     * @return gerundeter wert
     */
    //		public static function round(value : Number, decimal : int) : Number {
    //			// rueckgabewert
    //			var retval : Number = value;
    //			if (decimal > 0) {
    //				// multiplikator festsetzen -> hoch decimal
    //
    //				var multi : Number = (Math.pow(10, decimal));
    //				// komma verschieben
    //
    //				retval = value * multi;
    //				// runden
    //				//retval = Math.ceil(retval);
    //				retval = Math.round(retval);
    //				// komma zurueckverschieben
    //				retval = (retval / multi);
    //			}
    //			return retval;
    //		}

    public static roundDecimals(value: number, decimalPlaces: number): number {
        var k: number = int(Math.pow(10, decimalPlaces));

        value *= k;
        value = Math.floor(value);

        return value / k;
    }

    /**
     * Rounds a target number to the nearest multiple of another number.
     * @see Math#round
     */
    public static roundToNearest(numberToRound: number, nearest: number): number {
        return Math.round(numberToRound / nearest) * nearest;
    }

    /**
     * Rounds a target number up to the nearest multiple of another number.
     * @see Math#ceil
     */
    public static roundUpToNearest(numberToRound: number, nearest: number): number {
        return Math.ceil(numberToRound / nearest) * nearest;
    }

    /**
     * Rounds a target number down to the nearest multiple of another number.
     * @see Math#floor
     */
    public static roundDownToNearest(numberToRound: number, nearest: number): number {
        return Math.floor(numberToRound / nearest) * nearest;
    }

    /**
     * Rounds a target number to a specific number of decimal places.
     * @see Math#round
     */
    public static roundToPrecision(number: number, precision: number = 0): number {
        var decimalPlaces: number = Math.pow(10, precision);
        return Math.round(decimalPlaces * number) / decimalPlaces;
    }
}
